import { enableAccessSummaryUI, isCustomRolesEnabled, nonEnterpriseRoles } from '@gonfalon/dogfood-flags/dogfood-flags';

export function isAccessSummaryEnabled() {
  return enableAccessSummaryUI() && (isCustomRolesEnabled() || nonEnterpriseRoles());
}
